import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { type JSX,useEffect, useState } from "react";
import { Toaster } from "sonner";

import type { AuthContext } from "@/features/auth/hooks/useAuthentication";

interface RouterContext {
  // The ReturnType of your useAuth hook or the value of your AuthContext
  auth?: AuthContext;
}

/** Mirrors the `dark` class Topbar's theme toggle sets on <html>, so toasts match. */
function useIsDarkTheme(): boolean {
  const [isDark, setIsDark] = useState(
    () => typeof document !== "undefined" && document.documentElement.classList.contains("dark")
  );

  useEffect(() => {
    const html = document.documentElement;
    const observer = new MutationObserver(() => setIsDark(html.classList.contains("dark")));
    observer.observe(html, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  return isDark;
}

const RootLayout = (): JSX.Element => {
  const isDark = useIsDarkTheme();
  return (
    <>
      <Outlet />
      <Toaster theme={isDark ? "dark" : "light"} position="bottom-right" richColors />
      {/* <TanStackRouterDevtools /> */}
    </>
  );
};

export const Route = createRootRouteWithContext<RouterContext>()({ component: RootLayout });
